import { cn } from '../../../lib/stylingUtils';
import { Row, Col, Content, Footer } from '../../ui';
import { ContainedDataGrids } from '../../ui/collections/datagrid/DataGrid';
import { ListStatsCard, ListStatsCardProps } from '../ListStatsCard';

type ListScreenLayoutProps = {
  filters?: React.ReactNode;
  stats?: ListStatsCardProps['stats'];
  actions?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
};

export const ListScreenLayout = ({
  className,
  filters,
  stats,
  actions,
  children,
  footer,
}: ListScreenLayoutProps) => (
  <Col className={cn('@ListScreenLayout h-full pt-4', className)} gap4>
    {(filters || stats) && (
      <Col gap4 className={'px-4'}>
        {filters && (
          <Row gap2>
            {filters}
            {actions && (
              <Row gap2 className={'ml-auto'}>
                {actions}
              </Row>
            )}
          </Row>
        )}
        {stats && <ListStatsCard stats={stats} />}
      </Col>
    )}

    <Content className={cn('h-full px-4', !footer && 'pb-4', className)}>
      <ContainedDataGrids>{children}</ContainedDataGrids>
    </Content>

    {footer && <Footer>{footer}</Footer>}
  </Col>
);
